import React from 'react';

import { FieldTitle } from '../common/index';
import BrowserDetect from '../../browserDetect';
import BrowserLocation from '../../browserLocation';

function TextInput(props) {
  const { label, internalTitle, formId, required, placeholder, options, className } = props;
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
  const asterisk = required ? ' *' : null;
  const usedLabel = label.length ? (
    <label htmlFor={forId}>
      {label}
      {asterisk}
    </label>
  ) : null;

  /* eslint-disable complexity */
  function valueFromOptions(props) {
    let value;

    if (options && {}.hasOwnProperty.call(options, 'select_automatically')) {
      switch (internalTitle) {
        case 'browser_version':
          value = BrowserDetect.browserVersion();
          break;
        case 'os_version':
          value = BrowserDetect.osVersion();
          break;
        default:
          break;
      }
    }

    const uriParams = BrowserLocation.uriParams();
    const lastNameFromParam = uriParams.last_name;
    const fistNameFromParam = uriParams.first_name;

    switch (internalTitle) {
      case 'surname':
        value = lastNameFromParam === 'undefined' ? '' : lastNameFromParam;
        break;
      case 'name':
        value = fistNameFromParam === 'undefined' ? '' : fistNameFromParam;
        break;
      default:
        break;
    }

    value = props.options && props.options.value && props.options.value.length ? props.options.value : '';
    return value;
  }
  /* eslint-enable complexity */

  return (
    <div className={`${className} input text ${internalTitle}`}>
      {usedLabel}
      <input
        type="text"
        name={internalTitle}
        id={forId}
        required={required}
        maxLength={options.maxlength}
        placeholder={required && !label.length ? `${placeholder} *` : placeholder}
        defaultValue={valueFromOptions(props)}
      />
    </div>
  );
}

TextInput.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  className: React.PropTypes.string,
  options: React.PropTypes.object
};

TextInput.defaultProps = {
  className: 'formgroup'
};

export default TextInput;



// WEBPACK FOOTER //
// ./components/forms/textInput.js